import React from "react";
import { Spinner } from "react-bootstrap";

const RequestSidebarLoader: React.FC = () => {
  return (
    <div className="request-sidebar-loader" data-testid="request-sidebarLoader">
      <Spinner animation="border" />
    </div>
  );
};

export { RequestSidebarLoader };
